import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch, Redirect, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { useMediaQuery } from '@offerzen/pinata'

import InterviewRequestDetailScene from './scenes/InterviewRequestDetailScene'
import InterviewRequestListScene from './scenes/InterviewRequestListScene'
import MobileCompanyOverviewScene from './scenes/MobileCompanyOverviewScene'
import MobileInterviewEventsScene from './scenes/MobileInterviewEventsScene'
import MobileInterviewMessagesScene from './scenes/MobileInterviewMessagesScene'
import MobileJobSpecScene from './scenes/MobileJobSpecScene'
import { useRedirectToOnboarding } from '../CandidateExperience/hooks'

import './globalStyles'

const InterviewRequestsMain = ({ match, candidate }) => {
  const { isDesktopOrLarger } = useMediaQuery()
  useRedirectToOnboarding(candidate)

  return (
    <Choose>
      <When condition={isDesktopOrLarger}>
        <Switch>
          <Route
            exact
            path={`${match.path}/:interview_request_id/messages`}
            render={({ match: submatch }) => <Redirect to={`${match.url}/${submatch.params.interview_request_id}`} />}
          />
          <Route
            exact
            path={`${match.path}/:interview_request_id/interviews`}
            render={({ match: submatch }) => <Redirect to={`${match.url}/${submatch.params.interview_request_id}`} />}
          />
          <Route
            exact
            path={`${match.path}/:interview_request_id/company-overview`}
            render={({ match: submatch }) => <Redirect to={`${match.url}/${submatch.params.interview_request_id}`} />}
          />

          <Route exact path={`${match.path}/:interview_request_id`} component={InterviewRequestDetailScene} />
          <Route path={match.path} component={InterviewRequestListScene} />
        </Switch>
      </When>

      <Otherwise>
        <Switch>
          <Route exact path={`${match.path}/:interview_request_id/job-spec`} component={MobileJobSpecScene} />
          <Route exact path={`${match.path}/:interview_request_id/messages`} component={MobileInterviewMessagesScene} />
          <Route exact path={`${match.path}/:interview_request_id/interviews`} component={MobileInterviewEventsScene} />
          <Route exact path={`${match.path}/:interview_request_id/company-overview`} component={MobileCompanyOverviewScene} />
          <Route exact path={`${match.path}/:interview_request_id`} component={InterviewRequestDetailScene} />
          <Route path={match.path} component={InterviewRequestListScene} />
        </Switch>
      </Otherwise>
    </Choose>
  )
}

InterviewRequestsMain.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
    url: PropTypes.string,
  }),
  candidate: PropTypes.shape({}),
}

const mapStateToProps = state => ({
  candidate: state.candidate,
})

export default withRouter(connect(mapStateToProps)(InterviewRequestsMain))
